export const isMobileDevice = () =>
  /Mobi|Android|iPhone|iPad|iPod|Tablet/i.test(navigator.userAgent || "");
